/**
 * Printing
 * Case Studies
 */

import Vue from 'vue';

import CaseStudies from './components/CaseStudies';
import Quote from './components/Quote';
import Nav from './components/_nav';

import { commas, inMegabytes, mYYYY, price } from './lib';

Nav.nav();

Vue.filter('commas', commas);
Vue.filter('mYYYY', mYYYY);
Vue.filter('price', price);
Vue.filter('inMegabytes', inMegabytes);

const app = new Vue({
  el: '#app-root',
  created() {
    this.token = document.querySelector('meta[name=csrf-token]').content;
  },
  data: {
    token: '',
  },
  components: {
    'v-printing': CaseStudies,
    'v-quote': Quote,
  },
});



// WEBPACK FOOTER //
// ./printing.js